import React from 'react'
import { leagueAttendanceStore, AttendeeRecord } from 'state/league/leagueAttendance'

export type { AttendeeRecord }

interface AttendanceTableProps {
  data: AttendeeRecord[]
}

const SortToggle: React.FC = () => (
  <span className="att-sort-toggle">
    <span className="att-sort-up">▲</span>
    <span className="att-sort-dn">▼</span>
  </span>
)

const AttendanceTable: React.FC<AttendanceTableProps> = ({ data }) => {
  const { setManageAttendeeModal, setSelectedAttendee } =
    leagueAttendanceStore(store => ({
      setManageAttendeeModal: store.setManageAttendeeModal,
      setSelectedAttendee: store.setSelectedAttendee,
    }))

  const handleManage = (record: AttendeeRecord) => {
    setSelectedAttendee(record)
    setManageAttendeeModal(true)
  }

  return (
    <div className="att-table-wrapper">
      {/* Header */}
      <div className="att-table-header">
        <div className="att-col att-col-player">
          <span className="att-header-text">Player</span>
          <SortToggle />
        </div>
        <div className="att-col att-col-org">
          <span className="att-header-text">Organization</span>
          <SortToggle />
        </div>
        <div className="att-col att-col-team">
          <span className="att-header-text">Team</span>
          <SortToggle />
        </div>
        <div className="att-col att-col-division">
          <span className="att-header-text">Division</span>
          <SortToggle />
        </div>
        <div className="att-col att-col-checkin">
          <span className="att-header-text">Check-in date</span>
          <SortToggle />
        </div>
        <div className="att-col att-col-actions">
          <span className="att-header-text">Actions</span>
        </div>
      </div>

      {/* Rows */}
      {data.map(record => {
        const isExpanded = record.hasSubstitute

        return (
          <div
            key={record.key}
            className={`att-table-row ${isExpanded ? 'att-row-expanded' : ''}`}
          >
            {/* Player column */}
            <div className="att-col att-col-player att-cell-player">
              <span className="att-player-name">{record.name}</span>
            </div>

            {/* Organization column */}
            <div className="att-col att-col-org att-cell">
              {record.organization}
            </div>

            {/* Team column */}
            <div className="att-col att-col-team att-cell-team">
              {isExpanded ? (
                <>
                  <div className="att-team-slot att-team-primary">
                    <span className="att-team-badge att-badge-dash">
                      <span className="att-badge-text">-</span>
                    </span>
                    <span className="att-team-name">{record.team}</span>
                  </div>
                  <div className="att-connector" />
                  <div className="att-team-slot att-team-sub">
                    <span className="att-team-badge att-badge-dash">
                      <span className="att-badge-text">-</span>
                    </span>
                    <span className="att-team-name">{record.substituteTeam}</span>
                    <span className="att-sub-badge">Substitute</span>
                  </div>
                </>
              ) : (
                <div className="att-team-slot">
                  <span className="att-team-name">{record.team}</span>
                </div>
              )}
            </div>

            {/* Division column */}
            <div className={`att-col att-col-division att-cell ${isExpanded ? 'att-cell-top' : ''}`}>
              {record.division}
            </div>

            {/* Check-in date column */}
            <div className={`att-col att-col-checkin att-cell ${isExpanded ? 'att-cell-top' : ''}`}>
              {record.checkInDate}
            </div>

            {/* Actions column */}
            <div className={`att-col att-col-actions ${isExpanded ? 'att-cell-top' : ''}`}>
              <button
                className="att-manage-btn"
                onClick={() => handleManage(record)}
              >
                Manage
              </button>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default AttendanceTable
